
const firstChild = document.querySelectorAll('.flip-card:first-child');
const allFlipCards = document.querySelectorAll('.flip-card');

// Aca deberiamos limitar que esta funcion solo cargue en la pagina en cuestion
document.addEventListener('scroll', (e) => {
   if (firstChild.length > 0) {
     if (window.scrollY > 400) {
        firstChild[0].classList.add("flip-card-show")
     }
    
    
      setTimeout(function(){
      firstChild[0].classList.remove("flip-card-show")
    }, 2000);
   }
})



